module.exports = __webpack_public_path__ + "static/media/monthly_on.1f511993.png";